import { createContext, useContext, type ReactNode } from 'react'
import { useCurrentUnitState } from '@/modules/units/useCurrentUnitState'
import type { UnitContextType } from '@/modules/units/contexts/UnitContextTypes'

const UnitContext = createContext<UnitContextType | undefined>(undefined)

export function UnitProvider({ children }: { children: ReactNode }) {
  const unitState = useCurrentUnitState()

  return (
    <UnitContext.Provider value={unitState}>
      {children}
    </UnitContext.Provider>
  )
}

export function useUnit() {
  const context = useContext(UnitContext)

  if (!context) {
    throw new Error('useUnit must be used within a UnitProvider')
  }

  return context
}

export function useContextKey(): string {
  const { contextKey, currentUnit } = useUnit()

  const fixedEnvContext = import.meta.env.VITE_PUBLIC_APP_CONTEXT

  if (fixedEnvContext) return fixedEnvContext

  return currentUnit?.context_key || contextKey || 'farm'
}